<script>
    import { factoryStore } from "../store/factories";
    export let factorySettingId = "";
    import Select from "svelte-select";
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();

    let selectedItem;

    let mappedItems = [];
    updateMappedItems();

    async function updateMappedItems() {
        var x = await factoryStore.findFactorySettings("", 100000);
        var sortedItems = x.sort((a, b) => {
            return a.factory + a.version > b.factory + b.version ? 1 : -1;
        });
        mappedItems = sortedItems.map((i) => {
            return {
                value: i.uuid,
                label: i.factory + " - " + i.version,
                group: i.factory,
            };
        });
    }

    let initialSet = false;
    $: triggerSetSelected = setSelected(factorySettingId, mappedItems);

    function setSelected(cid) {
        if (!mappedItems || mappedItems.length == 0) return;
        if (cid && (!selectedItem || selectedItem.value != cid)) {
            selectedItem = mappedItems.find((i) => i.value == cid);
        } else {
            selectedItem == null;
        }
        window.setTimeout(() => {
            initialSet = true;
        }, 100);
    }

    $: triggerSetValue = setValue(selectedItem, mappedItems);
    function setValue(selected) {
        if (!mappedItems || mappedItems.length == 0) return;

        var bubble = false;
        if (
            (selected && selected.value != factorySettingId) ||
            (!selected && factorySettingId)
        )
            bubble = true;
        if (selected) {
            factorySettingId = selected.value;
        } else {
            factorySettingId = null;
        }
        if (bubble) bubbleChange();
    }
    function bubbleChange() {
        if (!initialSet) return;
        dispatch("change", { factorySettingId: factorySettingId });
    }
    let internalFactorySettingid;
</script>

<Select
    placeholder="type to filter"
    bind:items={mappedItems}
    bind:selectedValue={selectedItem}
    on:changeExternalValue
    itemFilter={(label, filterText, option) => {
        return filterText
            .toLowerCase()
            .split(" ")
            .every((word) => label.toLowerCase().includes(word));
    }}
/>

<!-- 
groupBy={(option) => {
    return option.group;
}}  getGroupHeaderLabel={(option) => {
        return option.label;
    }}

 itemFilter={(label, filterText, option) => {
        return filterText
            .toLowerCase()
            .split(" ")
            .every(
                (word) =>
                    label.toLowerCase().includes(word) ||
                    option.group.toLowerCase().includes(word)
            );
-->
